var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntwickeltFuerInvento1KPrimer = function SvgEntwickeltFuerInvento1KPrimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Entwickelt_fuer_Invento_1-K_Primer_svg__Ebene_2",
    viewBox: "0 0 100.61 87.13"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Entwickelt_fuer_Invento_1-K_Primer_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.94 85.76 1.58 43.56 25.94 1.37h48.72l24.37 42.19-24.37 42.2z",
    className: "Entwickelt_fuer_Invento_1-K_Primer_svg__cls-2"
  })), /*#__PURE__*/React.createElement("style", null, ".Entwickelt_fuer_Invento_1-K_Primer_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.74px}.Entwickelt_fuer_Invento_1-K_Primer_svg__cls-3{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Entwickelt_fuer_Invento_1-K_Primer_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Entwickelt_fuer_Invento_1-K_Primer_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.14 4 22.84 39.56-22.84 39.56H27.46L4.62 43.56 27.46 4zm1.52-2.63H25.94L1.58 43.56l24.36 42.19h48.72l24.36-42.19z",
    style: {
      fill: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.94 85.76 1.58 43.56 25.94 1.37h48.72l24.37 42.19-24.37 42.2z",
    className: "Entwickelt_fuer_Invento_1-K_Primer_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 59.52V33.24l-5.29 5.54-2.89-2.99 8.78-8.97h4.31v32.7h-4.9ZM37.85 49.57v-3.82h11.77v3.82zM74.37 59.52 62.7 45.3l-3.09 3.48v10.74h-4.9v-32.7h4.9v16.23l13.68-16.23h6.08L65.89 42.31l14.56 17.21z",
    className: "Entwickelt_fuer_Invento_1-K_Primer_svg__cls-3"
  }))));
};
export default SvgEntwickeltFuerInvento1KPrimer;